import { getStandardDialogTheme } from "./utils";
import { ContinueButton } from "../../Custom/Buttons";
import { ConversationalFormSettingsDialogProps } from "./type";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ThemeProvider,
} from "@mui/material";

import {
  ActionsContainer,
  HeaderContainer,
  PopupCloseIconComponent,
} from "./styled";

export default function ConversationalFormSettingsDialog({
  open,
  closeHandler,
  submitHandler,
  renderContent,
}: ConversationalFormSettingsDialogProps) {
  return (
    <ThemeProvider theme={getStandardDialogTheme()}>
      <Dialog open={open} scroll="paper" fullWidth maxWidth="md">
        <DialogTitle>
          <HeaderContainer>
            Conversational Form Settings
            <IconButton onClick={closeHandler}>
              <PopupCloseIconComponent />
            </IconButton>
          </HeaderContainer>
        </DialogTitle>
        <DialogContent>{renderContent()}</DialogContent>
        <DialogActions>
          <ActionsContainer>
            <ContinueButton onClick={submitHandler} />
          </ActionsContainer>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
